/**
 * Version de l'application Auto-Gère — figée au moment du build.
 *
 * À INCRÉMENTER À CHAQUE DÉPLOIEMENT (en parallèle de `APP_VERSION` dans
 * `backend/.env`). Le frontend compare cette valeur avec celle retournée
 * par `/api/version`. Si les deux diffèrent → un ancien bundle JS est
 * encore en cache chez l'utilisateur → on force un `window.location.reload(true)`.
 *
 * Format : « MAJOR.MINOR.PATCH »
 *   - MAJOR : refonte / breaking change UX
 *   - MINOR : feature notable visible côté utilisateur
 *   - PATCH : bugfixes, polish
 *
 * Date de poussée affichée dans la sidebar (footer) pour donner aux
 * utilisateurs un repère temporel sur les nouveautés.
 */
export const APP_VERSION   = "1.04.77";
export const APP_PUSHED_AT = "2026-10-12";

export default { APP_VERSION, APP_PUSHED_AT };
